import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiHealthIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.66699 1H6.33399V1.533H3.66699V1Z" />
            <path d="M5.7998 1.5332H6.3328V3.6672L8.9998 3.66699V6.33399H8.4668V6.3328H6.3328V8.4668H6.33399V8.9998H3.66699L3.6672 6.3328H1.5332V5.7998H4.2002V8.4668H5.7998V5.7998H8.4668V4.2002H5.7998V1.5332Z" />
            <path d="M4.2002 4.2002H1.5332V3.6672H3.6672L3.66699 1.533L4.2002 1.5332V4.2002Z" />
            <path d="M1 3.66699L1.5332 3.6672L1.533 6.33399H1V3.66699Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiHealthIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.66699 1H6.33399V1.533H3.66699V1Z" />
            <path d="M5.7998 1.5332H6.3328V3.6672L8.9998 3.66699V6.33399H8.4668V6.3328H6.3328V8.4668H6.33399V8.9998H3.66699L3.6672 6.3328H1.5332V5.7998H4.2002V8.4668H5.7998V5.7998H8.4668V4.2002H5.7998V1.5332Z" />
            <path d="M4.2002 4.2002H1.5332V3.6672H3.6672L3.66699 1.533L4.2002 1.5332V4.2002Z" />
            <path d="M1 3.66699L1.5332 3.6672L1.533 6.33399H1V3.66699Z" />
        </SvgIcon>
    );
};
